import styled from 'styled-components';

export const Container = styled.div`
  display: grid;

  @media screen and (max-width: 992px) {
    display: block;
    width: 100%;
  }
`;

export const SignupContainer = styled(Container)`
  grid-template-columns: 40% 60%;
`;

export const SigninContainer = styled(Container)`
  grid-template-columns: 40% 60%;
`;
